import { useAuth } from '@/contexts/AuthContext';

/**
 * Clip Studio is in beta. Access mirrors the `clips-proxy` edge function gate:
 * PODGO platform admins, plus individual users staff have flagged into the beta
 * via `profiles.clip_studio_enabled` (admin UserDetail toggle).
 *
 * Caveat: the upstream Clip Studio backend still attributes clips to a single
 * shared service session and does not yet honor the `X-Clip-User` header the
 * proxy sends, so beta users may see each other's clips.
 */
export function useClipStudioAccess(): boolean {
  const { hasRole, profile } = useAuth();
  return hasRole('admin') || profile?.clip_studio_enabled === true;
}
